export interface JwtPayload {
    exp: number;
    iat: number;
    sub: string;
    [key: string]: any;
}

export function parseJwt(token: string): JwtPayload | null {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );

        return JSON.parse(jsonPayload);
    } catch (e) {
        console.error('Failed to parse JWT', e);

        return null;
    }
}

export function isTokenExpired(token: string): boolean {
    const payload = parseJwt(token);

    return (!payload || !payload.exp) || (payload.exp * 1000 < Date.now());
}

export function getTokenExpiration(token: string): number {
    const payload = parseJwt(token);

    return payload && payload.exp ? payload.exp * 1000 : 0;
}
